import { TRASH_ICON } from "common/constants"
import notification from "common/utils/notification"
import { useContactosContext } from "features/Contactos/context/ContactosProvider"
import useContactos from "features/Contactos/hooks/useContactos"
import { Button } from "primereact/button"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import "./styles.scss"

const EliminarContacto = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const {
    // @ts-expect-error TS(2339): Property 'toggleShowDeleteContacto' does not exist...
    toggleShowDeleteContacto,
    // @ts-expect-error TS(2339): Property 'selectedContacto' does not exist on type...
    selectedContacto,
    // @ts-expect-error TS(2339): Property 'handleDeleteContactoHttp' does not exist...
    handleDeleteContactoHttp,
    // @ts-expect-error TS(2339): Property 'selectedMultipleContactos' does not exis...
    selectedMultipleContactos,
    // @ts-expect-error TS(2339): Property 'toggleShowDeleteMultipleContactos' does ...
    toggleShowDeleteMultipleContactos,
    // @ts-expect-error TS(2339): Property 'handleDeleteMultipleContactos' does not ...
    handleDeleteMultipleContactos,
  } = useContactosContext()

  const isContactosPage = window.location.pathname === ROUTES.CONTACTOS

  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { getContactosByFilters } = useContactos()

  const isMultiple = selectedMultipleContactos?.length > 1

  const handleDeleteMany = () => {
    handleDeleteMultipleContactos().then(() => {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      getContactosByFilters()
      toggleShowDeleteMultipleContactos()
    })
  }

  const handleDeleteOne = () => {
    handleDeleteContactoHttp().then(() => {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      getContactosByFilters()
      notification.success({
        body: `${t("msg.deleteContact")}`,
      })
      toggleShowDeleteContacto()
      if (!isContactosPage) history.push(ROUTES.CONTACTOS)
    })
  }

  return (
    <div className='eliminar-contactos w-100 d-flex flex-column justify-content-center align-items-center'>
      <img
        className='eliminar-contactos__icon'
        src={TRASH_ICON}
        alt='Eliminar-modal.svg'
      />
      <div className='mt-4 eliminar-contactos__title'>
        {`${t("contactos.eliminar.header")}${isMultiple ? "s" : ""}`}
      </div>
      <div className='mt-2 eliminar-contactos__message'>
        {isMultiple ? (
          <>
            {t("contactos.eliminar.deleteQuestionMultInit")}{" "}
            <span>{selectedMultipleContactos?.length}</span>{" "}
            {t("contactos.eliminar.deleteQuestionMultFinal")}
          </>
        ) : (
          <>
            {t("contactos.eliminar.deleteQuestionInit")}{" "}
            <span>{selectedContacto?.razonSocial}</span>{" "}
            {t("contactos.eliminar.deleteQuestionFinal")}
          </>
        )}
      </div>
      <div className='px-5 mt-4 w-100 d-flex justify-content-center'>
        <Button
          className='mr-3 text w-50 d-inline'
          onClick={
            isMultiple
              ? toggleShowDeleteMultipleContactos
              : toggleShowDeleteContacto
          }
        >
          {t("contactos.eliminar.cancelButton")}
        </Button>
        <Button
          className='danger w-50 d-inline'
          onClick={isMultiple ? handleDeleteMany : handleDeleteOne}
        >
          {t("contactos.eliminar.deleteButton")}
        </Button>
      </div>
    </div>
  )
}

export default EliminarContacto
